import { render } from "./CreateLabelSetFromFiltersModal.vue?vue&type=template&id=339a6c57&scoped=true"
import script from "./CreateLabelSetFromFiltersModal.vue?vue&type=script&lang=js"
export * from "./CreateLabelSetFromFiltersModal.vue?vue&type=script&lang=js"

import "./CreateLabelSetFromFiltersModal.vue?vue&type=style&index=0&id=339a6c57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339a6c57"]])

export default __exports__